import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    consentGiven: null,
    consentTimestamp: null,
    preferences: {
        necessary: true, // Always true, cannot be disabled
        analytics: false,
        advertisement: false
    },
    showBanner: false
};

const cookieConsentSlice = createSlice({
    name: 'cookieConsent',
    initialState,
    reducers: {
        setConsentGiven: (state, action) => {
            state.consentGiven = action.payload;
            state.consentTimestamp = action.payload ? new Date().toISOString() : null;
        },
        updatePreferences: (state, action) => {
            state.preferences = { ...state.preferences, ...action.payload };
        },
        acceptAll: (state) => {
            state.consentGiven = true;
            state.consentTimestamp = new Date().toISOString();
            state.preferences = {
                necessary: true,
                analytics: false,
                advertisement: false
            };
            state.showBanner = false;
        },
        rejectAll: (state) => {
            state.consentGiven = true;
            state.consentTimestamp = new Date().toISOString();
            state.preferences = {
                necessary: true,
                analytics: false,
                advertisement: false
            };
            state.showBanner = false;
        },
        showConsentBanner: (state) => {
            state.showBanner = true;
        },
        hideConsentBanner: (state) => {
            state.showBanner = false;
        },
        saveCustomPreferences: (state, action) => {
            state.consentGiven = true;
            state.consentTimestamp = new Date().toISOString();
            state.preferences = { ...state.preferences, ...action.payload };
            state.showBanner = false;
        }
    }
});

export const {
    setConsentGiven,
    updatePreferences,
    acceptAll,
    rejectAll,
    showConsentBanner,
    hideConsentBanner,
    saveCustomPreferences
} = cookieConsentSlice.actions;

export default cookieConsentSlice.reducer;
